import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import Loader from '../common/Loader';

const RootRoute: React.FC = () => {
  const { isAuthenticated, isLoading, authInitialized, hasGroupAccess } = useAuth();
  const location = useLocation();
  const [timeoutReached, setTimeoutReached] = useState(false);
  
  // **Check if we're trying to access supplier portal**
  const isSupplierPortalAccess = location.pathname.includes('/supplier/');
  
  // **If accessing supplier portal, don't interfere**
  if (isSupplierPortalAccess) {
    console.log("[ROOT-ROUTE] Supplier portal access, not handling");
    return null; // Let supplier routes handle themselves
  }
  
  // Timeout-Effekt: Nach 8 Sekunden weitergehen, egal was passiert
  useEffect(() => {
    const timer = setTimeout(() => {
      console.log("[ROOT-ROUTE] Auth timeout reached");
      setTimeoutReached(true);
    }, 8000);
    
    return () => clearTimeout(timer);
  }, [isLoading, authInitialized]);
  
  // Wenn im Lade-Status und kein Timeout
  if ((isLoading || !authInitialized) && !timeoutReached) {
    console.log("[ROOT-ROUTE] Loading auth state");
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center' 
      }}>
        <Loader size="large" text="Authentifizierung wird geladen..." />
      </div>
    );
  }
  
  // Wenn Timeout erreicht wurde, aber Auth immer noch lädt:
  if (timeoutReached && (isLoading || !authInitialized)) {
    const hasToken = localStorage.getItem('token') || 
                     localStorage.getItem('msal.idtoken') ||
                     Object.keys(localStorage).some(key => key.includes('msal'));
                     
    console.log("[ROOT-ROUTE] Timeout-Navigation, Token gefunden:", !!hasToken);
    return <Navigate to={hasToken ? "/dashboard" : "/login"} replace />;
  }
  
  // Normale Navigation basierend auf Auth-Status
  console.log("[ROOT-ROUTE] Auth status:", { isAuthenticated, hasGroupAccess });
  
  // **RootRoute leitet nur zwischen Admin Dashboard und Login weiter**
  // **Supplier Portal ist komplett unabhängig**
  
  if (isAuthenticated && hasGroupAccess) {
    console.log("[ROOT-ROUTE] Authenticated with group access, going to dashboard");
    return <Navigate to="/dashboard" replace />;
  }
  
  console.log("[ROOT-ROUTE] Not authenticated or no group access, going to login");
  return <Navigate to="/login" replace />;
};

export default RootRoute;